import React from 'react'
import ReactIdSwiper from 'react-id-swiper'

export default function ArSwiper ({ children, inversePaginationColor }) {
  const params = {
    pagination: {
      el: `._ArSwiper__pagination${ inversePaginationColor ? '._ArSwiper__pagination--inverse' : '' }`,
      type: 'bullets',
      clickable: false,
    },
  }

  return (
    <ReactIdSwiper {...params}>
      {children}
    </ReactIdSwiper>
  )
}
